const pieChartData = [
  {
    id: "Proposal Pending",
    value: 594,
    color: "hsl(125, 70%, 50%)",
  },
  {
    id: "Payment Pending",
    value: 415,
    color: "hsl(200, 70%, 50%)",
  },
  {
    id: "COI Issuance Pending",
    value: 51,
    color: "hsl(135, 70%, 50%)",
  },
  {
    id: "COI Not Generated",
    value: 235,
    color: "hsl(276, 70%, 50%)",
  },
];

export { pieChartData };
